var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgNotice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 42,
    viewBox: "0 0 47 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4094",
    "data-name": "\\uADF8\\uB8F9 4094",
    transform: "translate(-15 -395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2960",
    "data-name": "\\uD328\\uC2A4 2960",
    d: "M19.05,41.1H0V26.549C0,12.749,7.2,2.4,19.05.15V9.6c-4.8,1.05-8.7,6.9-8.849,12.3H19.05Zm27.3,0H27.15V26.4C27.3,12.6,34.5,2.25,46.349,0V9.45c-4.8,1.049-8.7,6.9-8.7,12.449h8.7Z",
    transform: "translate(15 395)",
    fill: "#0365ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2504",
    "data-name": "\\uC0AC\\uAC01\\uD615 2504",
    width: 47,
    height: 42,
    transform: "translate(15 395)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgNotice);
export default __webpack_public_path__ + "static/media/bgNotice.7b01fca0554658f225aee91a4f9127d9.svg";
export { ForwardRef as ReactComponent };